<template>
  <v-container>
    <!-- Header -->
    <v-toolbar
      color="primary"
      class="my-3"
      dark
    >
      <v-toolbar-title>{{ $t('contracts.pageName') }}</v-toolbar-title>
    </v-toolbar>

    <VAutocomplete
      v-if="siteLoaded"
      v-model="selectedSite"
      :items="sites"
      itemText="name"
      :label="$t('contracts.siteSelection')"
    />

    <v-data-table
      :headers="contractHeaders"
      :items="contracts"
      :itemsPerPage="5"
      class="elevation-1"
      :footerProps="{
        itemsPerPageText: $t('contracts.footers.rowPerPage')
      }"
    >
      <template v-slot:item.contractNumber="{ item }">
        <span>{{ item.contractNumber }}</span>
      </template>

      <template v-slot:item.contractStartDate="{ item }">
        <span>{{ formatDate(item.contractStartDate) }}</span>
      </template>

      <template v-slot:item.contractEndDate="{ item }">
        <span>{{ formatDate(item.contractEndDate) }}</span>
      </template>
      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        {{ $t('contracts.footers.of',{pageStart, pageStop, itemsLength}) }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    data() {
        return {
            contracts: [],
            sites: [],
            selectedSite: null,
            siteLoaded: false,
        };
    },
    computed: {
        ...mapGetters([
            'team',
        ]),
        contractHeaders() {
            return [
                { text: this.$t('contracts.contractNumber'), value: 'contractNumber' },
                { text: this.$t('contracts.type'), value: 'contractType' },
                { text: this.$t('contracts.startDate'), value: 'contractStartDate' },
                { text: this.$t('contracts.endDate'), value: 'contractEndDate' },
                { text: this.$t('contracts.lastContractValue'), value: 'lastContractValue' },
                { text: this.$t('contracts.actions'), value: 'action' },
            ];
        },
    },
    watch: {
        async selectedSite(newSiteId, oldSiteId) {
            if (newSiteId !== oldSiteId) {
                this.selectedSite = newSiteId;
                await this.getContracts();
            }
        },
    },
    async created() {
        await this.getSites();
    },
    methods: {
        async getContracts() {
            const result = await this.$rq.getContractsForTeam({ teamId: this.team.id, siteId: this.selectedSite });
            this.contracts = result.data;
        },
        async getSites() {
            const result = await this.$rq.getSites();
            this.sites = result.data.sites;
            this.siteLoaded = true;
        },
        formatDate(dateStr) {
            return dateStr ? this.$options.filters.formatDate(dateStr) : null;
        },
    },
};
</script>
